import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["choice", "inputs"]
  static values = { max: Number, selected: Array }

  connect() {
    this.ids = (this.hasSelectedValue ? this.selectedValue : []).map((id) => String(id))
    this.render()
  }

  toggle(event) {
    const id = event.currentTarget.dataset.tacticId
    const index = this.ids.indexOf(id)
    if (index >= 0) {
      this.ids.splice(index, 1)
    } else if (this.ids.length < this.limit()) {
      this.ids.push(id)
    }
    this.render()
  }

  render() {
    this.inputsTarget.innerHTML = this.ids.map((id) => {
      return `<input type="hidden" name="tactic_ids[]" value="${id}">`
    }).join("")

    this.choiceTargets.forEach((choice) => {
      const rank = this.ids.indexOf(choice.dataset.tacticId) + 1
      choice.classList.toggle("is-selected", rank > 0)
      choice.setAttribute("aria-pressed", rank > 0 ? "true" : "false")
      const badge = choice.querySelector("[data-tactic-rank]")
      if (!badge) return

      badge.hidden = rank === 0
      badge.textContent = rank > 0 ? String(rank) : ""
    })
  }

  limit() {
    return this.hasMaxValue && this.maxValue > 0 ? this.maxValue : 3
  }
}
